var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"js-notifications-spinner\"><div class=\"text-center padding-bottom-4x padding-top-2x\"><i class=\"fa fa-2x fa-spin fa-spinner text-base-color\"></i></div></div>");;return buf.join("");
}